import React from 'react';
import configData from '../../../temp/config';

const GenderList = (props) => {
    let items = props.data    
    let icons = props.icons

    /* Display the gender lsit in the table based on the props */
    return items.map( (data, index) => {
        return <span key={index}>
        {
            icons !== null ?
            icons.map((icon, index) => {
                let imgPath = `${configData.sitecoreApiHost}${icon.genderLogo}`
                return icon.genderTitle === data && <img key={index} src={imgPath} alt={data} />
            }) : 
            data                
        }
        </span>
    })
}

export default GenderList
